module.exports = __webpack_public_path__ + "static/img/装饰4.23de989.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/jewelryPendant/imgs/装饰4.svg
// module id = d7rB
// module chunks = 2